module.exports = __webpack_public_path__ + "img/svg1.ef2cd342.svg";